import React from 'react';
import PropTypes from 'prop-types';
import {
    RefreshButtonDefault,
    RefreshButtonNewData,
    RefreshButtonStopGenerating,
} from './RefreshIcons.react';

const InsightsRefresh = (props) => {
    const {
        isFigureValid,
        isDataChanged,
        isGenerating,
        onRefresh,
        onStopGenerating,
        onDataChangeRefresh,
    } = props;
    if (isGenerating) {
        return <RefreshButtonStopGenerating onClick={onStopGenerating} />;
    }
    if (!isFigureValid) {
        return null;
    }
    if (isDataChanged) {
        return <RefreshButtonNewData onClick={onDataChangeRefresh} />;
    }
    return <RefreshButtonDefault onClick={onRefresh} />;
};
InsightsRefresh.propTypes = {
    isFigureValid: PropTypes.bool,
    isDataChanged: PropTypes.bool,
    isGenerating: PropTypes.bool,
    onDataChangeRefresh: PropTypes.func,
    onStopGenerating: PropTypes.func,
    onRefresh: PropTypes.func,
};

export default InsightsRefresh;
